// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { IconButton } from '@carbon/react';
import { Add, CenterCircle, Subtract } from '@carbon/icons-react';

export interface GraphZoomControlsProps {
  onZoomIn: () => void;
  onZoomOut: () => void;
  onFit: () => void;
  zoomPercent: number;
}

/**
 * Zoom controls, stacked bottom-left inside the canvas.
 *
 * The zoom level is announced rather than displayed: the design keeps the
 * canvas chrome to three buttons, but a keyboard or screen-reader user zooming
 * with `+`/`-` gets no visual cue at all otherwise.
 */
export const GraphZoomControls = ({
  onZoomIn,
  onZoomOut,
  onFit,
  zoomPercent,
}: GraphZoomControlsProps) => (
  <div className="kg-zoom">
    <IconButton label="Zoom in" kind="ghost" size="sm" align="right" onClick={onZoomIn}>
      <Add size={16} />
    </IconButton>
    <IconButton label="Zoom out" kind="ghost" size="sm" align="right" onClick={onZoomOut}>
      <Subtract size={16} />
    </IconButton>
    <IconButton label="Fit to view" kind="ghost" size="sm" align="right" onClick={onFit}>
      <CenterCircle size={16} />
    </IconButton>
    <span className="sld-sr-only" aria-live="polite">
      Zoom {zoomPercent}%
    </span>
  </div>
);
